import { EvilIcons } from "@expo/vector-icons";
import { View } from "react-native-ui-lib";

export const ProductPlaceholder = ({}) => {
  return (
    <View
      style={{
        width: "100%",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        backgroundColor: "#e4e4e4",
        flex: 1,
        borderRadius: 4,
      }}
    >
      <EvilIcons
        name="image"
        size={80}
        color="black"
        style={{ opacity: 0.3 }}
      />
    </View>
  );
};
